module.exports = "/_next/static/images/desktop_hero_id-02b31d737bbabcfb4e0740cf6c696466.webp";